// extracted by mini-css-extract-plugin
module.exports = {"appButton":"styles_appButton__Njfi1","primary":"styles_primary__sTUrd","secondary":"styles_secondary__ybH5Z","tertiary":"styles_tertiary__68Owt"};